import { Component } from 'react';
import './pill.css';

class Pill extends Component {
  render() {
    const { active, label, hidePointer, isSmall, onClick } = this.props;
    return (
      <div
        className={`mb-1 text-center ${hidePointer ? '' : 'pointer'} ${
          isSmall ? 'Pill-container-small' : 'Pill-container'
        } ${active ? 'font-weight-bold Game-Session-Form-icon-active' : ''}`}
        onClick={onClick}
      >
        <div className="px-1 center Pill-font">{label}</div>
      </div>
    );
  }
}

export default Pill;
